import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'ck-ui';
import { Configure, InstantSearch } from 'react-instantsearch/dom';
import { algoliaClient, INDEX_PRODUCTS, userToken } from 'src/lib/algolia';
import '../index.global.scss';

const CuratedBundle = React.lazy(() => import('../productList/CuratedProductList/CuratedBundle'));
const CuratedLook = React.lazy(() => import('../productList/CuratedProductList/CuratedLook'));

const CuratedCollectionPage = ({ listName, bundle, featureImage }) => {
  const collectionHandle = window.location.pathname.split('/').filter(x => x && x !== 'collections')[0];
  const filters = `isOnline:true AND collectionHandles:${collectionHandle}`;

  return (
    <InstantSearch
      indexName={`${INDEX_PRODUCTS}_default`}
      searchClient={algoliaClient}
    >
      <Configure
        userToken={userToken}
        hitsPerPage={60}
        filters={filters}
        ruleContexts={[`collection-${collectionHandle}`]}
        clickAnalytics
        analyticsTags={['web', 'collection', 'curated', bundle ? 'bundle' : 'look', collectionHandle]}
      />
      <Suspense fallback={<Loading isLoading />}>
        {bundle ? (
          <CuratedBundle listName={listName} bundle={bundle} featureImage={featureImage} />
        ) : (
          <CuratedLook listName={listName} featureImage={featureImage} />
        )}
      </Suspense>
    </InstantSearch>
  );
};

CuratedCollectionPage.propTypes = {
  listName: PropTypes.string.isRequired,
  featureImage: PropTypes.string.isRequired,
  bundle: PropTypes.object
};

CuratedCollectionPage.defaultProps = {
  bundle: null
};

export { CuratedCollectionPage };
